export const data = {
  heading: `METHODOLOGY`,
  list: [
    `Segment conducted this research using online surveys distributed by Method Communications, between April and May 2022.`,
    `There were a total of 3,450 respondents from Australia, Brazil, Colombia, France, Germany, Italy, Japan, Mexico, Singapore, Spain, United Kingdom, and United States, with a minimum of 250 respondents from each country.`,
    `To ensure our report incorporated both business and consumer attitudes towards personalization, we conducted two surveys.`,
    `Our consumer survey targeted adult consumers who have purchased something online in the past 6 months. These respondents were equally split across gender.`,
    `In addition, we also surveyed B2B and B2C business managers and above who are familiar with their company's customer experience, marketing tech, or customer data strategies.`,
  ],
}
